import React , { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  Box, Typography, Button, Grid, TableContainer, Table, TableHead,
  TableBody, TableRow, Paper, TextareaAutosize, Modal, Select, MenuItem, Snackbar, Alert,Checkbox
} from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import CreatePackage from '../shipment/CreatePackage'
import legolasApi from '../../api/legolas'
import legolasConfig from '../../api/legolas';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function AddCreditMemo() {
 // const { state: { data, type } } = useLocation()
  const location = useLocation();
  const data = location?.state?.data || null;
  const type = location?.state?.type || null;
  // console.log("data: ", data);
  const { items, shipment, summary, transaction, customer } = data;
  const navigate = useNavigate();
  const [pageType, setPageType] = React.useState('creditMemo');
  const [openPackage, setOpenPackage] = React.useState(false);
  const [packageDetails, setPackageDetails] = React.useState({});
  const [shippingPartnerId, setShippingPartnerId] = React.useState(1);
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')
  const [returnedQtyChecked, setReturnedQtyChecked] = React.useState(false)
  const [creditmemoTaxAmount, setCreditmemoTaxAmount] = React.useState(0)
  const [creditmemoSubtotal, setCreditmemoSubtotal] = React.useState(0)
  const [creditmemoGrandtotal, setCreditmemoGrandtotal] = React.useState(0)
  const [creditmemoCouponDiscount, setCreditmemoCouponDiscount]= React.useState(0)
  const [creditmemoCodFee, setCreditmemoCodFee] = React.useState(0)
  const [creditmemoTamaraFee, setCreditmemoTamaraFee] = React.useState(0)
  const [creditmemoTabbyFee, setCreditmemoTabbyFee] = React.useState(0)
  const [creditmemoShippingAmount, setCreditmemoShippingAmount] = React.useState(0)
  const [adjustmentPositive, setAdjustmentPositive] = React.useState(0)
  const [adjustmentNegative, setAdjustmentNegative] = React.useState(0)
  const [isGiftChecked, setIsGiftChecked] = React.useState(false);
  const [disabledCreditMemoSubmitBtn, setDisabledCreditMemoSubmitBtn] = React.useState(false);
  
  React.useEffect(() => {
    if (type === 'shipment') {
      setPageType('shipment')
    }
    if (summary && summary.shippingId) {
      setShippingPartnerId(summary.shippingId)
      setCreditmemoSubtotal(summary.subtotal_incl_tax)
      setCreditmemoGrandtotal(summary.grand_total)
      setCreditmemoCodFee(summary.cod_fee_incl_tax)
      setCreditmemoTamaraFee(summary.tamara_fee_incl_tax)
      setCreditmemoTabbyFee(summary.tabby_fee_incl_tax)
      setCreditmemoShippingAmount(summary.shipping_incl_tax)
      setCreditmemoTaxAmount(summary.total_tax)
      setCreditmemoCouponDiscount(summary.discount_amount)
    }
    items.forEach(item => {
      setQtyRefund(item, item.quantity);
      setReturnItemStock(item);
    });
  }, [])

  const handleChange = (item, checkValue) => {
    item.returnStock = checkValue
    // console.log("Stock: ",items);
  };

  const setReturnItemStock = (item) => {
    item.returnStock = returnedQtyChecked;
  };

  const setQtyRefund = (item, qtyRefund) => {
    item.qtyRefund = qtyRefund;
  }
  const handleCheckboxChange = (item) => (event) => {
    const checked = event.target.checked;
    setIsGiftChecked(checked)
   
  };
  const handleSubmit = () => {
    let grandTotal = 0;
    let totalPrice = 0;
    let totalTaxPrice = 0;
    let totalTax = 0;
    let totalCouponDiscount = 0.00;
    items.forEach(item => {
      if(parseFloat(item.qtyRefund) > 0 && parseFloat(item.qtyRefund) > parseFloat(item.quantity)){
        alert("Refund qty should not be greater than actual quantity");
        return;
      }else if (parseFloat(item.qtyRefund) > 0) {
        const qtyRefund = parseFloat(item.qtyRefund);
        const discount = parseFloat(item.discount);
        const itemPrice = parseFloat(item.price_incl_tax)
        const itemTaxPrice = parseFloat(item.tax_amount)
        const rowPrice = itemPrice * qtyRefund
        // const rowTax = itemTaxPrice * qtyRefund
        const rowTax = (itemTaxPrice/parseFloat(item.quantity)) * qtyRefund;
        totalPrice = totalPrice + rowPrice
        totalTaxPrice = totalTaxPrice + rowTax
        if(parseFloat(summary.discount_amount) > 0 && parseInt(summary.order_id) > parseInt(process.env.REACT_APP_LAST_ORDER_ID)){
          totalCouponDiscount = totalCouponDiscount + (discount * qtyRefund);
        }else if(parseFloat(summary.discount_amount) > 0 && discount > 0){
          totalCouponDiscount = totalCouponDiscount + (discount * qtyRefund);
        }
        else if(parseFloat(summary.discount_amount) > 0 && discount == 0){
          totalCouponDiscount = totalCouponDiscount + parseFloat(((itemPrice * qtyRefund * parseFloat(process.env.REACT_APP_DISCOUNT_PERCENT)) /100))
        }else if(item.is_gift_product == 1){
          totalCouponDiscount = totalCouponDiscount + (discount * qtyRefund);
        }
      }
    });
    
    totalPrice = parseFloat(totalPrice).toFixed(2);
    setCreditmemoSubtotal(totalPrice);
    totalTax = parseFloat(totalTaxPrice).toFixed(2);
    setCreditmemoTaxAmount(parseFloat(totalTax).toFixed(2));
    totalCouponDiscount =parseFloat(totalCouponDiscount).toFixed(2);
    setCreditmemoCouponDiscount(totalCouponDiscount);

    grandTotal = (
        parseFloat(totalPrice) 
      + parseFloat(creditmemoShippingAmount) 
      + parseFloat(creditmemoCodFee)
      + parseFloat(creditmemoTamaraFee)
      + parseFloat(creditmemoTabbyFee)
      + parseFloat(adjustmentPositive)
      - parseFloat(adjustmentNegative)
      - parseFloat(totalCouponDiscount)
    ).toFixed(2);
    setCreditmemoGrandtotal(parseFloat(grandTotal));
  }

  const adjustCodFee = (data, cod_fee_incl_tax) => {
    let grandTotal = 0;
    let codFee = !isNaN(parseFloat(cod_fee_incl_tax) ) ? parseFloat(cod_fee_incl_tax).toFixed(2): "0.00";
    data.cod_fee_incl_tax = codFee
    setCreditmemoCodFee(codFee)
    grandTotal = (
        parseFloat(creditmemoSubtotal) 
      + parseFloat(creditmemoShippingAmount) 
      + parseFloat(codFee)
      + parseFloat(creditmemoTamaraFee)
      + parseFloat(creditmemoTabbyFee)
      + parseFloat(adjustmentPositive)
      - parseFloat(adjustmentNegative)
      - parseFloat(creditmemoCouponDiscount)
    ).toFixed(2)
    setCreditmemoGrandtotal(grandTotal)
  }

  const adjustTamaraFee = (data, tamara_fee_incl_tax) => {
    let grandTotal = 0;
    let tamaraFee = !isNaN(parseFloat(tamara_fee_incl_tax) ) ? parseFloat(tamara_fee_incl_tax).toFixed(2): "0.00";
    data.tamara_fee_incl_tax = tamaraFee
    setCreditmemoTamaraFee(tamaraFee)
    grandTotal = (
        parseFloat(creditmemoSubtotal) 
      + parseFloat(creditmemoShippingAmount) 
      + parseFloat(creditmemoCodFee)
      + parseFloat(tamaraFee)
      + parseFloat(adjustmentPositive)
      - parseFloat(adjustmentNegative)
      - parseFloat(creditmemoCouponDiscount)
    ).toFixed(2)
    setCreditmemoGrandtotal(grandTotal)
  }

  const adjustTabbyFee = (data, tabby_fee_incl_tax) => {
    let grandTotal = 0;
    let tabbyFee = !isNaN(parseFloat(tabby_fee_incl_tax) ) ? parseFloat(tabby_fee_incl_tax).toFixed(2): "0.00";
    data.tabby_fee_incl_tax = tabbyFee
    setCreditmemoTabbyFee(tabbyFee)
    grandTotal = (
        parseFloat(creditmemoSubtotal) 
      + parseFloat(creditmemoShippingAmount) 
      + parseFloat(creditmemoCodFee)
      + parseFloat(tabbyFee)
      + parseFloat(adjustmentPositive)
      - parseFloat(adjustmentNegative)
      - parseFloat(creditmemoCouponDiscount)
    ).toFixed(2)
    setCreditmemoGrandtotal(grandTotal)
  }

  const adjustPositive = (data, adjustment_positive) => {
    let grandTotal = 0;
    let additionValue = adjustment_positive ? parseFloat(adjustment_positive).toFixed(2) : 0.00;
    data.adjustment_negative = additionValue
    // console.log("adjustPositive", data.adjustment_negative);
    setAdjustmentPositive(parseFloat(additionValue).toFixed(2));
    
    grandTotal = (
        parseFloat(creditmemoSubtotal) 
      + parseFloat(creditmemoShippingAmount) 
      + parseFloat(creditmemoCodFee)
      + parseFloat(creditmemoTamaraFee)
      + parseFloat(creditmemoTabbyFee)
      + parseFloat(additionValue)
      - parseFloat(adjustmentNegative)
      - parseFloat(creditmemoCouponDiscount)
    ).toFixed(2)
    setCreditmemoGrandtotal(grandTotal)
  }

  const adjustNegtive = (data, adjustment_negative) => {
    let grandTotal = 0;
    let deductValue = adjustment_negative ? parseFloat(adjustment_negative).toFixed(2) : 0.00;
    data.adjustment_negative = deductValue
    // console.log("adjustPositive", data.adjustment_negative);
    setAdjustmentNegative(parseFloat(deductValue).toFixed(2));
    
    grandTotal = (
        parseFloat(creditmemoSubtotal) 
      + parseFloat(creditmemoShippingAmount) 
      + parseFloat(creditmemoCodFee)
      + parseFloat(creditmemoTamaraFee)
      + parseFloat(creditmemoTabbyFee)
      + parseFloat(adjustmentPositive)
      - parseFloat(deductValue)
      - parseFloat(creditmemoCouponDiscount)
    ).toFixed(2)
    setCreditmemoGrandtotal(grandTotal)
  }
  const adjustShippingAmount = (data, shipping_incl_tax) => {
    let grandTotal = 0;
    // let shippingFee = shipping_incl_tax ? parseFloat(shipping_incl_tax).toFixed(2) : 0.00;
    let shippingFee = !isNaN(parseFloat(shipping_incl_tax)) ? parseFloat(shipping_incl_tax).toFixed(2) : "0.00";

    data.shipping_incl_tax = shippingFee
    setCreditmemoShippingAmount(shippingFee)
     
    grandTotal = (
        parseFloat(creditmemoSubtotal) 
      + parseFloat(shippingFee) 
      + parseFloat(creditmemoCodFee)
      + parseFloat(creditmemoTamaraFee)
      + parseFloat(creditmemoTabbyFee)
      + parseFloat(adjustmentPositive)
      - parseFloat(adjustmentNegative)
      - parseFloat(creditmemoCouponDiscount)
    ).toFixed(2)
    setCreditmemoGrandtotal(grandTotal)
  }

  useEffect(() => {
  let total = (
      parseFloat(creditmemoSubtotal || 0)
    + parseFloat(creditmemoShippingAmount || 0)
    + parseFloat(creditmemoCodFee || 0)
    + parseFloat(creditmemoTamaraFee || 0)
    + parseFloat(creditmemoTabbyFee || 0)
    + parseFloat(adjustmentPositive || 0)
    - parseFloat(adjustmentNegative || 0)
    - parseFloat(creditmemoCouponDiscount || 0)
  ).toFixed(2);

  setCreditmemoGrandtotal(total);
}, [
  creditmemoSubtotal,
  creditmemoShippingAmount,
  creditmemoCodFee,
  creditmemoTamaraFee,
  creditmemoTabbyFee,
  adjustmentPositive,
  adjustmentNegative,
  creditmemoCouponDiscount
]);

  const backClickHandler = () => {
    const orderId = summary['order_id']
    const redirectUrl = `/orders/${orderId}`
    navigate(redirectUrl)
  }

  const darkBox = {
    width: '97%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '97%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }

  const subHeader = {
    fontSize: '1.2rem',
    fontWeight: 700,
    paddingBottom: '20px'
  }

  const handleInvoiceorShipmentSubmit = async () => {
    let filteredItems = items;
      const summary = data.summary
      let storeId;
      console.log("process.env.SENSI_CHANEEL",`${legolasConfig.sensiChannelId}`);
      if (process.env.REACT_APP_SENSI_CHANNEL_ID == summary.channel_id) {
          if (summary.magento_store_id === 1) {
              storeId = 3;
          } else if (summary.magento_store_id === 2) {
              storeId = 4;
          }
      } else {
          storeId = summary.magento_store_id;
      }
      // console.log('summaryhhh: ', summary)
      let submitPayload = {
        orderId: summary.order_id ? summary.order_id : '',
        orderDate: summary.placedOn ? summary.placedOn : '',
        orderTime: summary.orderTime ? summary.orderTime : null,
        billingAddress: shipment ? shipment : {},
        shippingAddress: shipment ? shipment : {},
        shippingMethod: data.shippingMethod,
        shippingCharges: creditmemoShippingAmount,
        // items: items ? items : [],
        items: filteredItems ? filteredItems  :[],
        discount_amount: creditmemoCouponDiscount ? creditmemoCouponDiscount : 0,
        shipping_amount: creditmemoShippingAmount,
        adjustment_positive: adjustmentPositive,
        adjustment_negative: adjustmentNegative,
        subtotal: creditmemoSubtotal,
        totalVat: creditmemoTaxAmount,
        grandTotal: creditmemoGrandtotal,
        cod_fee_incl_tax: creditmemoCodFee,
        tamara_fee_incl_tax: creditmemoTamaraFee,
        tabby_fee_incl_tax: creditmemoTabbyFee,
        storeId: storeId,
        channelId:summary.channel_id
      }
      setDisabledCreditMemoSubmitBtn(true);
      console.log("submitPayload",submitPayload)
      axios.post(`${legolasApi.url}/admin/creditmemo/add`, submitPayload).then((res) => {
        console.log('Submit creditmemo res: ', res)
        const data = res.data
        if (data.success) {
          handleAlertGen(data.message)
        }
        setDisabledCreditMemoSubmitBtn(false);
      }).catch((error) => {
        console.log('Error in submit res: ', error)
        setDisabledCreditMemoSubmitBtn(false);
      })
  }


  const closePackage = () => {
    setOpenPackage(false)
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      backClickHandler()
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }

  const purchasedFromDefault = 'Shababuna Website'
  const purchasedIPDefault = 'NULL'
  // const computedGrandTotal = (parseFloat(summary.grand_total) || 0) + (parseFloat(summary.one_day_delivery_charge) || 0);

  
 

  if (data === null) return null


  return (
    <Box sx={{ height: 'auto', margin: '10px 20px' }}>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{ display: 'flex' }}>
        {
          pageType === 'shipment' ?
            <Typography variant='h4'>New Shipment</Typography> :
            <Typography variant='h4'>New Memo</Typography>
        }
      </Box>
      <Box sx={{
        display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: globalStyles.colors.backgroundPrimary,
          color: globalStyles.colors.white,
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
      }}
      >
        <Button onClick={() => backClickHandler()}>Back</Button>
        <Button>Reset</Button>
      </Box>

      <Box id='order-container'>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>Order & Account Information</Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Order # {summary.order_id} (The order confirmation email was sent)
            </Typography>
            <Box sx={darkBox}>
              <Typography>Order Date</Typography>
              <Typography>{summary.placedOn}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Order Status</Typography>
              {summary.order_status ?
                <Typography>{summary.order_status}</Typography> : <Typography sx={{ color: 'red' }}>Order status not set</Typography>}
            </Box>
             <Box sx={darkBox}>
                <Typography>Same Day Delivery </Typography>
                <Typography>{Number(summary.one_day_delivery_charge) > 0 ? "True" : "False"}</Typography>
              </Box>
            
            {/* <Box sx={darkBox}>
              <Typography>Purchased From</Typography>
              {summary.purchasedFrom ?
                <Typography>{summary.purchasedFrom}</Typography> : <Typography>{purchasedFromDefault}</Typography>}
            </Box> */}
           {/* <Box sx={lightBox}>
              <Typography>Purchased From IP</Typography>
              {summary.order_ip ?
                <Typography>{summary.order_ip}</Typography> : <Typography>{purchasedIPDefault}</Typography>}
            </Box>
              */}
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Account Information
            </Typography>
            <Box sx={darkBox}>
              <Typography>Customer Name</Typography>
              <Typography>{shipment.customer_firstname + ' ' + shipment.customer_lastname}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Email</Typography>
              <Typography>{customer.email ? customer.email : null}</Typography>
            </Box>
            <Box sx={darkBox}>
              <Typography>Customer Group</Typography>
              <Typography>GENERAL</Typography>
              {/*{customer.user_group_code ? <Typography>{customer.user_group_code}</Typography> : <Typography sx={{ color: 'red' }}>Group not set</Typography>}*/}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='address-container' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>Address Information</Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Billing Address
            </Typography>
            <Box>
              {shipment.customer_firstname && shipment.customer_lastname ?
                <Typography>
                  {shipment.customer_firstname + ' ' + shipment.customer_lastname}
                </Typography> :
                null
              }
            </Box>
            <Box>
              {shipment.street ?
                <Typography>{shipment.street}</Typography> : null
              }
            </Box>
            <Box>
              {shipment.city && shipment.district ?
                <Typography>
                  {shipment.city + ', ' + shipment.district}
                </Typography> :
                null}
            </Box>
            <Box>
              {shipment.country ? <Typography>{shipment.country}</Typography> : null}
            </Box>
            <Box>
              {shipment.phone_ext && shipment.phone ?
                <Typography>
                  T : {shipment.phone_ext + shipment.phone}
                </Typography> :
                null}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Shipping Address
            </Typography>
            <Box>
              {shipment.customer_firstname && shipment.customer_lastname ?
                <Typography>
                  {shipment.customer_firstname + ' ' + shipment.customer_lastname}
                </Typography> :
                null
              }
            </Box>
            <Box>
              {shipment.street ?
                <Typography>{shipment.street}</Typography> : null
              }
            </Box>
            <Box>
              {shipment.city && shipment.district ?
                <Typography>
                  {shipment.city + ', ' + shipment.district}
                </Typography> :
                null}
            </Box>
            <Box>
              {shipment.country ? <Typography>{shipment.country}</Typography> : null}
            </Box>
            <Box>
              {shipment.phone_ext && shipment.phone ?
                <Typography>
                  T : {shipment.phone_ext + shipment.phone}
                </Typography> :
                null}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='payment-container' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>Payment & Shipping Method</Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Payment Information
            </Typography>
            <Box>
            {transaction.paymentType && (
                <Typography>{transaction.paymentType}</Typography>
              )}
            </Box>
            <Box>
            {transaction.last4Digits && (
                <Typography>{transaction.last4Digits}</Typography>
              )}
            </Box>
            <Box>
            {transaction.paymentBrand && (
                <Typography>{transaction.paymentBrand}</Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Shipping Information
            </Typography>
            <Box>
              <Typography>
                {[summary.shippingId] == 2 ? 'Aramex Shipping' : 'Shababuna Shipping'}
              </Typography>
            </Box>
            <Box>
              <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontWeight: 500 }}>
                Total Shipping Charges: <Typography sx={{ fontSize: '1.1rem', fontWeight: 700 }}>SAR {summary.shipping_incl_tax}</Typography>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='items-container' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          {
            pageType === 'shipment' ?
              <Typography variant='h6'>Items to Ship</Typography> :
              <Typography variant='h6'>Items Refunded</Typography>
          }
        </Box>
        <Box>
          <TableContainer component={Paper} sx={{ paddingTop: '30px' }}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">Product</StyledTableCell>
                  <StyledTableCell align="center">Product ID</StyledTableCell>
                  <StyledTableCell align="center">Product Mage ID</StyledTableCell>
                  <StyledTableCell align="center">Price</StyledTableCell>
                  <StyledTableCell align="center">Quantity</StyledTableCell>
                  {/* <StyledTableCell align="center">Return to Stock</StyledTableCell> */}
                  <StyledTableCell align="center">Qty to Refund</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item) => (
                  <StyledTableRow key={item.id}>
                    <StyledTableCell component="th" scope="row">
                    {item.name}<span><b>{(item.is_gift_product && item.is_gift_product === 1) ? " ( This is the Gift Item )" : ""}</b></span>
                    </StyledTableCell>
                    <StyledTableCell align="center">{item.id}</StyledTableCell>
                      <StyledTableCell align="center">{item.mageId}</StyledTableCell>
                      <StyledTableCell align="center">{item.price_incl_tax}</StyledTableCell>
                      <StyledTableCell align="center">{item.quantity}</StyledTableCell>
                      {/* <StyledTableCell align="center">
                        <input type="checkbox" name={item.sku} id={item.sku}
                        onChange={(e) => handleChange(item, e.target.checked)} />
                      </StyledTableCell> */}
                      <Typography align="center">
                        <input type="text"
                          style={{ width: '1.5rem', marginTop: '0.7rem' }}
                          defaultValue={item.quantity}
                          onChange={(e) => setQtyRefund(item, e.target.value)}
                          name="refund_qty" /></Typography>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              sx={{
                backgroundColor: '#2b3f7a !important',
                borderRadius: 0,
                padding: '5px 10px',
                color: '#fff',
                textTransform: 'capitalize'
              }}
              onClick={handleSubmit}
            >
              <Typography>Update Qty's</Typography>
            </Button>
            <Typography sx={{ color: 'red' }}>Adjust 'Qty to Refund' in above input box <br />
              and click on this button in case of RMA credit memo</Typography>

          </Box>
        </Box>
      </Box>
      <Box id='total-container' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          {
            pageType === 'shipment' ?
              <Typography variant='h6'>Shipment Total</Typography> :
              <Typography variant='h6'>Order Total</Typography>
          }
        </Box>
        <Grid container spacing={5} columns={24} sx={{ flexDirection: 'row-reverse' }}>
          {/* <Grid item xs={12}>
            {
              pageType === 'shipment' ?
                <Typography variant='subtitle1' sx={subHeader}>
                  Shipment Comments
                </Typography> :
                <Typography variant='subtitle1' sx={subHeader}>
                  Credit Memo History
                </Typography>
            }
            <Box>
              <TextareaAutosize
                aria-label="minimum height"
                minRows={5}
                placeholder={pageType === 'shipment' ? 'Shipment Comments' : 'Credit Memo Comments'}
                style={{ width: 500 }}
              />
            </Box>
          </Grid> */}
          <Grid item xs={12}>
            {
              pageType === 'shipment' ?
                <Typography variant='subtitle1' sx={subHeader}>
                  Shipment Options
                </Typography> :
                <Typography variant='subtitle1' sx={subHeader}>
                  Refund Totals
                </Typography>
            }
            {
              pageType === 'shipment' ?
                <Box>
                  <Button sx={globalStyles.shippingOptionsButton} onClick={() => setOpenPackage(true)}>Create Shipping Label</Button>
                  <Modal
                    open={openPackage}
                    onClose={closePackage}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <CreatePackage closePackage={closePackage} setPackageDetails={setPackageDetails} items={items} />
                  </Modal>
                  <Button sx={globalStyles.shippingOptionsButton}>Append Comments</Button>
                </Box> :
                <Box sx={{ paddingBottom: '10px' }}>
                  <Box sx={darkBox}>
                    <Typography>Subtotal (incl. Tax)</Typography>
                      <Typography>
                       SAR {parseFloat(creditmemoSubtotal).toFixed(2)}
                      </Typography>
                  </Box>
                  <Box sx={lightBox}>
                    <Typography>Tax</Typography>
                      <Typography>
                        SAR {parseFloat(creditmemoTaxAmount).toFixed(2)}
                      </Typography>
                  </Box>
                  <Box sx={darkBox}>
                    <Typography>Coupon Discount</Typography>
                     <Typography>SAR {parseFloat(creditmemoCouponDiscount).toFixed(2)}</Typography>
                  </Box>
                  <Box sx={lightBox}>
                    <Typography>Shipping & Handling</Typography>
                    <Typography>
                      <input type="text"
                        style={{ width: '3rem' }}
                        name="shipping_fee"
                        defaultValue={parseFloat(summary.shipping_incl_tax).toFixed(2)}
                        onChange={(e) => adjustShippingAmount(data, e.target.value)} />
                    </Typography>
                  </Box>
                  <Box sx={darkBox}>
                    <Typography>Adjustment Refund</Typography>

                    <Typography sx={{ color: 'red' }} >
                      <input type="text"

                        style={{ width: '3rem' }}
                        onChange={(e) => adjustPositive(data, e.target.value)} /></Typography>
                  </Box>
                  <Box sx={lightBox}>
                    <Typography>Adjustment Fee</Typography>
                    <Typography>
                      <input type="text"
                        style={{ width: '3rem' }}
                        onChange={(e) => adjustNegtive(data, e.target.value)} /></Typography>
                  </Box>
                 
                  <Box sx={darkBox}>
                    <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
                    <Typography>
                      <input type="text"
                        style={{ width: '3rem' }}
                        name="cod_fee"
                        defaultValue={parseFloat(summary.cod_fee_incl_tax).toFixed(2)}
                        onChange={(e) => adjustCodFee(data, e.target.value)} />
                    </Typography>
                  </Box>
                  <Box sx={darkBox}>
                    <Typography>Tamara Processing Fee </Typography>
                    <Typography>
                      <input type="text"
                        style={{ width: '3rem' }}
                        name="tamara_fee"
                        defaultValue={parseFloat(summary.tamara_fee_incl_tax).toFixed(2)}
                        onChange={(e) => adjustTamaraFee(data, e.target.value)} />
                    </Typography>
                  </Box>
                  <Box sx={darkBox}>
                    <Typography>Tabby Processing Fee </Typography>
                    <Typography>
                      <input type="text"
                        style={{ width: '3rem' }}
                        name="tabby_fee"
                        defaultValue={
                          !isNaN(parseFloat(summary.tabby_fee_incl_tax)) 
                            ? parseFloat(summary.tabby_fee_incl_tax).toFixed(2) 
                            : '0.00'
                        }                        
                        onChange={(e) => adjustTabbyFee(data, e.target.value)} />
                    </Typography>
                  </Box>
                    {Number(summary.one_day_delivery_charge) > 0 && (
                                   <Box sx={lightBox}>
                                     <Typography>Next Day Delivery Fee</Typography>
                                     <Typography>SAR {parseFloat(summary.one_day_delivery_charge).toFixed(2)}</Typography>
                                   </Box>
                                 )}
                  <Box sx={darkBox}>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 700 }}>Grand Total</Typography>
                    <Typography>
                      {/* SAR {parseFloat(creditmemoGrandtotal).toFixed(2)} */}
                      SAR {isNaN(parseFloat(creditmemoGrandtotal)) ? "0.00" : parseFloat(creditmemoGrandtotal).toFixed(2)}
                                      {/* <Typography>SAR {computedGrandTotal.toFixed(2)}</Typography> */}
                      
                    </Typography>
                  </Box>
                </Box>
            }
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <Button
                sx={{
                  backgroundColor: '#2b3f7a !important',
                  borderRadius: 0,
                  padding: '15px 20px',
                  color: '#fff',
                  textTransform: 'capitalize'
                }}
                disabled={disabledCreditMemoSubmitBtn}
                onClick={() => handleInvoiceorShipmentSubmit()}
              >
                {
                  pageType === 'shipment' ?
                    <Typography>Submit Shipment</Typography> :
                    <Typography>{disabledCreditMemoSubmitBtn ? "Submitting ......" : "Submit Credit Memo"}</Typography>
                }
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default AddCreditMemo;